import AppHeader from '../AppHeader'

export default {
  name: 'moral',
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    }
  },
  components: {
    AppHeader
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral.js